import React from 'react';
import { Check } from 'lucide-react';
import { Card, SectionTitle } from '../ui';
import { GRAPH_STYLES, useGraphStyle } from '../graph/GraphStyle';

export default function GraphStylePreference() {
  const [style, setStyle] = useGraphStyle();
  return (
    <Card className="p-8 mt-4" data-testid="graph-style-preference">
      <SectionTitle>Visualizzazione del grafo</SectionTitle>
      <p className="text-sm text-[#8A8F97] mb-6">Vale per il grafo delle relazioni, il grafo AML e il grafo inserito nei PDF.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {GRAPH_STYLES.map((s) => (
          <button key={s.id} type="button" onClick={() => setStyle(s.id)} className={`design-opt ${style === s.id ? 'on' : ''}`} data-testid={`graph-style-option-${s.id}`} aria-pressed={style === s.id}>
            <img src={s.img} alt={`Anteprima ${s.label}`} />
            <div className="flex items-center justify-between gap-2 p-3">
              <p className="font-semibold text-sm">{s.label}</p>
              {style === s.id && <span className="w-6 h-6 rounded-full grid place-items-center bg-[#D4AF37] text-[#050505] shrink-0"><Check size={13} /></span>}
            </div>
          </button>
        ))}
      </div>
    </Card>
  );
}
